module.exports = __webpack_public_path__ + "static/abnt-24231404fc0cf8d1ad34fae5f45743e1.png";